import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = {
  height: 64,
  bg: "backgroundNavbar",
  color: "text",
  position: "sticky",
  top: 0,
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  alignItems: "center",
  px: 6,
  zIndex: 100,
  boxShadow: "navbar",
}

export const search: SxStyleProp = {
  width: "100%",
}
